const SITE_URL = import.meta.env.VITE_SITE_URL || "https://example.com";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "EducationalOrganization",
  "@id": `${SITE_URL}/#organization`,
  name: "Instituto Ashaika",
  alternateName: "Ashaika",
  url: SITE_URL,
  logo: `${SITE_URL}/favicon.ico`,
  description:
    "Instituto Ashaika: líder en formación certificada de Biomagnetismo Médico, Método Yuen, Hipnosis Terapéutica y Bioenergética en México. Más de 15 años transformando vidas en Zapopan, Jalisco.",
  telephone: "+523325077743",
  email: "info@institutoashaika.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Juan Kepler 4052A",
    addressLocality: "Zapopan",
    addressRegion: "Jalisco",
    postalCode: "45070",
    addressCountry: "MX",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 20.7167,
    longitude: -103.4,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "19:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Saturday"],
      opens: "09:00",
      closes: "14:00",
    },
  ],
  sameAs: [
    "https://www.instagram.com/alonso_ashaika/",
    "https://www.facebook.com/Ashtair.Ashaika/",
    "https://youtube.com/channel/UC-4Sh1ohGBnO-6trq-sw6LA/",
    "https://www.tiktok.com/@dralonsoashaika",
  ],
  founder: {
    "@type": "Person",
    name: "Alonso Ashaika",
    jobTitle: "Terapeuta y Formador en Terapias Alternativas",
  },
  numberOfEmployees: {
    "@type": "QuantitativeValue",
    minValue: 1,
  },
  areaServed: {
    "@type": "Country",
    name: "México",
  },
};

const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: "Instituto Ashaika",
  description:
    "Formación certificada en Biomagnetismo Médico, Hipnosis Terapéutica, Método Yuen y Bioenergética en Zapopan, Jalisco, México.",
  publisher: {
    "@id": `${SITE_URL}/#organization`,
  },
  inLanguage: "es-MX",
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": `${SITE_URL}/#webpage`,
  url: SITE_URL,
  name: "Instituto Ashaika | Biomagnetismo, Hipnosis y Terapias Alternativas - Zapopan, Jalisco",
  description:
    "Instituto Ashaika en Zapopan, Jalisco: formación certificada en Biomagnetismo Médico, Hipnosis Terapéutica, Método Yuen y Bioenergética. Más de 15 años transformando vidas con terapias alternativas en México.",
  isPartOf: { "@id": `${SITE_URL}/#website` },
  about: { "@id": `${SITE_URL}/#organization` },
  inLanguage: "es-MX",
  dateModified: "2026-04-07",
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "HealthAndBeautyBusiness"],
  "@id": `${SITE_URL}/#localbusiness`,
  name: "Instituto Ashaika",
  image: `${SITE_URL}/favicon.ico`,
  url: SITE_URL,
  telephone: "+523325077743",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Juan Kepler 4052A",
    addressLocality: "Zapopan",
    addressRegion: "Jalisco",
    postalCode: "45070",
    addressCountry: "MX",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 20.7167,
    longitude: -103.4,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "19:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Saturday"],
      opens: "09:00",
      closes: "14:00",
    },
  ],
  hasMap: "https://maps.google.com/?q=Juan+Kepler+4052A+Arboledas+Zapopan+Jalisco",
  sameAs: [
    "https://www.instagram.com/alonso_ashaika/",
    "https://www.facebook.com/Ashtair.Ashaika/",
    "https://youtube.com/channel/UC-4Sh1ohGBnO-6trq-sw6LA/",
    "https://www.tiktok.com/@dralonsoashaika",
  ],
};

const coursesSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Cursos y Programas - Instituto Ashaika",
  description:
    "Programas de formación certificada en terapias alternativas: Biomagnetismo Médico, Hipnosis Terapéutica, Método Yuen y más.",
  url: `${SITE_URL}/#cursos`,
  numberOfItems: 6,
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      item: {
        "@type": "Course",
        name: "Biomagnetismo Médico",
        description:
          "Formación completa en Biomagnetismo Médico con certificación reconocida. Aprende a identificar y equilibrar campos magnéticos para la salud.",
        provider: { "@id": `${SITE_URL}/#organization` },
        url: `${SITE_URL}/#cursos`,
        inLanguage: "es-MX",
        availableLanguage: "Spanish",
        courseMode: ["onsite", "online"],
      },
    },
    {
      "@type": "ListItem",
      position: 2,
      item: {
        "@type": "Course",
        name: "Hipnosis Terapéutica Avanzada",
        description:
          "Domina las técnicas de hipnosis terapéutica para el tratamiento de traumas, fobias y transformación personal.",
        provider: { "@id": `${SITE_URL}/#organization` },
        url: `${SITE_URL}/#cursos`,
        inLanguage: "es-MX",
        availableLanguage: "Spanish",
        courseMode: ["onsite", "online"],
      },
    },
    {
      "@type": "ListItem",
      position: 3,
      item: {
        "@type": "Course",
        name: "Método Yuen",
        description:
          "Técnica de fortalecimiento energético basada en la medicina china y la kinesiología para eliminar debilidades del sistema.",
        provider: { "@id": `${SITE_URL}/#organization` },
        url: `${SITE_URL}/#cursos`,
        inLanguage: "es-MX",
        availableLanguage: "Spanish",
        courseMode: ["onsite", "online"],
      },
    },
    {
      "@type": "ListItem",
      position: 4,
      item: {
        "@type": "Course",
        name: "Bioenergética y Leyes Biológicas",
        description:
          "Comprende las leyes que rigen los procesos biológicos y energéticos del cuerpo humano para la sanación integral.",
        provider: { "@id": `${SITE_URL}/#organization` },
        url: `${SITE_URL}/#cursos`,
        inLanguage: "es-MX",
        availableLanguage: "Spanish",
        courseMode: ["onsite", "online"],
      },
    },
  ],
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "¿Qué es el Biomagnetismo Médico?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "El Biomagnetismo Médico es una terapia alternativa que utiliza imanes de mediana intensidad para identificar y equilibrar el pH del cuerpo, eliminando patógenos y restaurando la salud. El Instituto Ashaika ofrece formación certificada en esta técnica en Zapopan, Jalisco.",
      },
    },
    {
      "@type": "Question",
      name: "¿Dónde está ubicado el Instituto Ashaika?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "El Instituto Ashaika está ubicado en Juan Kepler 4052A, Colonia Arboledas, Zapopan, Jalisco, CP 45070, México. También ofrecemos cursos y sesiones terapéuticas en modalidad online para todo el mundo.",
      },
    },
    {
      "@type": "Question",
      name: "¿Los cursos del Instituto Ashaika tienen certificación?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sí, todos los programas del Instituto Ashaika otorgan certificaciones reconocidas. Contamos con más de 500 alumnos certificados en Biomagnetismo Médico, Hipnosis Terapéutica, Método Yuen y otras terapias alternativas.",
      },
    },
    {
      "@type": "Question",
      name: "¿Cómo puedo inscribirme a un curso?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Puedes inscribirte contactándonos por WhatsApp al +52 33 2507 7743, llenando el formulario de contacto en nuestra página web, o visitándonos directamente en nuestra sede en Zapopan, Jalisco.",
      },
    },
    {
      "@type": "Question",
      name: "¿Ofrecen sesiones terapéuticas individuales?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sí, el Instituto Ashaika ofrece sesiones terapéuticas individuales de Biomagnetismo, Hipnosis Terapéutica, Método Yuen y otras terapias alternativas, tanto presenciales en Zapopan como en modalidad online.",
      },
    },
  ],
};

export default function SeoJsonLd() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(coursesSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}
